import ApplicationAdapter from 'eflex/adapters/application';

export default class StationAdapter extends ApplicationAdapter {
  namespace = 'locations';
}
